
<app-header></app-header>
<div class="newHome" translate="no">
    <section class="hero">
        <div class="container">
            <div class="row">
                <div class="col-sm-5">
                    <div class="text-end logoSec">
                        <img src="/assets/images/kisan_logo_white.png" alt="KISAN Logo" class="logoK" />
                        <h4 class="mb-1">9 – 13 Dec 2026 Pune</h4>
                        <h5>9:00 AM to 5:00 PM</h5>
                    </div>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-5">
                    <div>
                        <img class="w-100" src="/assets/images/text-img.png" alt="Logo" />
                        <h5 class="mt-4 line">Join 2,00,000 visitors and 600+ exhibitors. 
                        Explore cutting-edge agri-tech, farming solutions and  networking opportunities!

                        </h5>
                        <div class="mt-4" *ngIf="showBuyTicketButton">
                            <a class="button tktBook" (click)="onBuyTickets()">
                                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" />  -->
                                    Book your Ticket    
                                <span><i class="fa fa-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pavilion-wrapper" [ngClass]="{'d-none': hidePavilionSection}" *ngIf="eventDetails?.show_digital_catalog">
                <div class="layout d-flex justify-content-between flex-column flex-md-row">
                    <h3 class="tit text-white">KISAN Pavilions</h3>
                       
                </div>
                
                <div class="mSection d-flex" *ngIf="!isLoadingPavilions && allPavilions?.length">
                    <div class="grp pragati">
                        <div class="pGrp">
                            <div class="sng" *ngFor="let pavilion of allPavilions">
                                <div class="img-Wrapper">
                                    <img [src]="pavilion.image_url" [alt]="pavilion.name"
                                    (click)="onClickCatalog(pavilion)"
                                    (keydown.enter)="onClickCatalog(pavilion)"
                                    tabindex="0"
                                    role="button"/>
                                </div>
                                <h6 class="text-center mt-2 text-white"
                                    (click)="onClickCatalog(pavilion)"
                                    (keydown.enter)="onClickCatalog(pavilion)"
                                    tabindex="0"
                                    role="button">{{ pavilion.name }}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-loader text-left" *ngIf="isLoadingPavilions">
                    <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>           
        </div>

        <div class="actBtn text-center mt-4 d-flex justify-content-center align-items-center flex-column flex-md-row">
            <a class="button text-start ps-4" (click)="onBuyTickets()" *ngIf="showBuyTicketButton">
                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                Book your Ticket 
                <span><i class="fa fa-arrow-right"></i></span>
            </a>           
            <a class="button catalogLink" routerLink="/catalogue/pavilion-list" *ngIf="eventDetails?.show_digital_catalog">
                <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                View Catalogue
                <span><i class="fa fa-arrow-right"></i></span>
            </a>
        </div>
    </section>

    <section>
        <div class="container">
            <video class="mt-4" #homeVideo autoplay muted loop playsinline preload="auto" width="100%">
                <source src="/assets/images/me/details_video.mp4" type="video/mp4">
            </video>
        </div>
    </section>

    <section class="attend">
        <div class="container">
            <div class="gprMain">
                <div class="row grp">
                    <div class="col-md-6">
                        <div class="sec tagLine">
                            <!-- <h3 class="font-weight-600">Why Attend</h3> -->
                            <h1 class="green">Why attend 
                                <br>KISAN 2026</h1>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/exhibitor.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">600+ Exhibitors</h5>
                            <p>Meet India’s top agri-brands and innovators.</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/users.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">2,00,000 Visitors</h5>
                            <p>Farmers, entrepreneurs, and agri-enthusiasts from across the country.</p>
                        </div>
                    </div>
                </div>

                <div class="row grp">
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/productsicon.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">2000+ Agri Products & Services</h5>
                            <p>Explore wide range of products.</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec">
                            <img src="/assets/images/me/network.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">Networking Opportunities</h5>
                            <p>Connect, Collaborate & Network</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="sec PavilionSlider">
                            <div class="compInterest">
                                <div class="containerd">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <h5 class="font-weight-600 mt-3 mb-4">12+ Specialized Pavilions</h5>
                                        <a class="catalogBtn" routerLink="/catalogue/pavilion-list">View Catalogue</a>
                                    </div>
                                    <div class="linear-slider">
                                        <div class="slider-track" #sliderTrack>
                                            <!-- First set -->
                                            <div class="slide" *ngFor="let logo of logos">
                                                <img [src]="logo.img" alt="logo" />
                                            </div>
                                            <!-- Duplicate set for seamless looping -->
                                            <div class="slide" *ngFor="let logo of logos">
                                                <img [src]="logo.img" alt="logo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row grp">
                    <div class="col-md-6">
                        <div class="sec area">
                            <img src="/assets/images/me/ground_icon.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">73,000 Sq. m. Event Area</h5>
                            <!-- <img src="/assets/images/me/map_animation.gif" alt="icon" /> -->
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec two">
                            <img src="/assets/images/me/stall_space.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">26,000 Sq. m. Display Area</h5>
                            <p>Experience machinery, tools, and agri solutions up close.</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="sec two">
                            <img src="/assets/images/me/parking.png" alt="icon" />
                            <h5 class="font-weight-600 mt-3">50,000 Sq. m. Parking</h5>
                            <p>Stress-free access for all attendees.</p>
                        </div>
                    </div>
                </div>

                <div class="actBtn text-center mt-4 d-flex justify-content-center align-items-center flex-column flex-md-row">
                    <a class="button text-start ps-4" (click)="onBuyTickets()" *ngIf="showBuyTicketButton">
                        <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                        Book your Ticket
                        <span><i class="fa fa-arrow-right"></i></span>
                    </a>
                     <a class="button catalogLink"  href="https://pune.kisan.in/detailed-layout" target="_blank" *ngIf="eventDetails?.show_digital_catalog">
                        <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                        Explore Layout
                        <span><i class="fa fa-arrow-right"></i></span>
                    </a>
                </div>

            </div>
        </div>
    </section>


    <section class="ticketSlider d-none">
        <div class="container p-0">
            <h1 class="tit font-weight-600 text-center mb-4">Choose the Right Pass for You</h1>
            <div class="slider-container d-none" (mouseenter)="pauseAutoSlide()" (mouseleave)="startAutoSlide()">
                <div class="slider-track">
                    <div class="tkt-slide slide" *ngFor="let slide of slides; let i = index"
                        [ngClass]="slidePositions[i]">
                        <div class="type" [ngClass]="slide.class">
                            <div class="text-center">
                                <img [src]="slide.icon" [alt]="slide.title" />
                                <h3 class="font-weight-600 mt-3 mb-4">{{ slide.title }}</h3>
                            </div>
                            <div class="d-flex align-items-start mt-1" *ngFor="let pt of slide.points">
                                <i class="fa-solid fa-circle-check pt-1"></i>
                                <p class="ms-2">{{ pt }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="slider d-flex flex-column flex-md-row mb-5 justify-content-center">
                <div class="slide d-none">
                    <div class="firstDay type">
                        <div class="text-center">
                            <img src="/assets/images/me/firstday_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">First Day Ticket</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Single Entry Access to Day 1 only</p>
                        </div>
                        <!-- <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">सकाळी ९ वाजता शेतकऱ्यांच्या हस्ते होणाऱ्या उद्घाटन सोहळ्यात सहभागी व्हा</p>
                        </div> -->
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Be among the first to explore KISAN 2025</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="singleEntry type">
                        <div class="text-center">
                            <img src="/assets/images/me/single_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">Single Entry </h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Single Entry Access on any one day</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Ideal for farmers and visitors who wish to visit on any event day</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="allDay type">
                        <div class="text-center">
                            <img src="/assets/images/me/allday_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">All Day Pass</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Access for all 5 days of KISAN 2025</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Explore everything without missing a thing at your own pace</p>
                        </div>
                    </div>
                </div>
                <div class="slide d-none">
                    <div class="business type">
                        <div class="text-center">
                            <img src="/assets/images/me/business_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">Business Pass</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">All days + Networking Lounge & B2B pavilion Access</p>
                        </div>
                        <div class="d-flex align-items-start mt-1">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Exclusive for business visitors, startups, and professionals</p>
                        </div>
                    </div>
                </div>
                <div class="slide">
                    <div class="child type">
                        <div class="text-center">
                            <img src="/assets/images/me/child_icon.png" alt="icon" />
                            <h3 class="font-weight-600 mt-3 mb-4">Child Ticket</h3>
                        </div>
                        <div class="d-flex align-items-start">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Single-day entry. Must be accompanied by a parent</p>
                        </div>
                        <div class="d-flex align-items-start mt-2">
                            <i class="fa-solid fa-circle-check pt-1"></i>
                            <p class="ms-2">Introduce young minds to the future of farming</p>
                        </div>
                    </div>
                </div>
                    
                </div>
            <div class="text-center mt-4" *ngIf="showBuyTicketButton">
                <a (click)="onBuyTickets()" class="button">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    Book Your Ticket
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>

            <div style="height: 60px;"></div>
        </div>
    </section>



    <section class="tktStep pt-0 d-none">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-5">Book Your Ticket in 3 Easy Steps</h1>
            <div class="stepList d-flex flex-column flex-md-row">
                <div class="step">
                    <div class="head d-flex">
                        <div class="num">1</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">Select tickets & pay</h4>
                            <p class="mb-4">Pick the ticket that fits your schedule.</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/select-tkt.gif" alt="step1" />
                    </div>
                </div>

                <div class="step">
                    <div class="space"></div>
                    <div class="head d-flex">
                        <div class="num">2</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">Fill Your Details</h4>
                            <p class="mb-4">Quick, safe, and secure registration.</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/assign-tkt.gif" alt="step2" />
                    </div>
                </div>

                <div class="step">
                    <div class="space"></div>
                    <div class="space"></div>
                    <div class="head d-flex">
                        <div class="num">3</div>
                        <div class="ms-3">
                            <h4 class="font-weight-600">Get Your QR Code</h4>
                            <p class="mb-4">Show it at the gate and enjoy the Agri Show!</p>
                        </div>
                    </div>
                    <div class="imageOut">
                        <img class="w-100" src="/assets/images/me/my-tkt.gif" alt="step3" />
                    </div>
                </div>
            </div>
            <div class="text-center mt-4" *ngIf="showBuyTicketButton">
                <a (click)="onBuyTickets()" class="button">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    Book Your Ticket
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>
        </div>
    </section>

    <section class="location pb-0">
        <div class="container">
            <h1 class="tit font-weight-600 text-center pt-0">KISAN 2026 Details</h1>
            <div class="imgO">
            <video class="mt-4" #homeVideo autoplay muted loop playsinline preload="auto" width="100%">
                <source src="/assets/images/me/map.mp4" type="video/mp4">
            </video>
                <div class="info">
                    <div>
                        <h3>Dates</h3>
                        <h2>9 – 13 Dec 2026</h2>
                    </div>
                    <div>
                        <h3>Timing</h3>
                        <h2>9:00 AM To 5:00 PM</h2>
                    </div>
                    <div>
                        <h3>Location</h3>
                        <h2>Pune, India</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="testimonials">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-5">What Visitors Are Saying</h1>
            <div class="row">
                <!-- <div class="col-sm-3"> </div> -->
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/visitor.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/visitor.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>रमेश</h4>
                            <h6>शेतकरी</h6> -->
                            <!-- <p>"आम्ही किसान आलो याचा आम्हाला खूप आनंद आहे! तिकीट दर खूपच परवडणारे होते आणि आम्हाला खूप
                                मौल्यवान माहिती मिळाली. धन्यवाद, किसान!"</p> -->
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/exhibitor.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/exhibitor.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>अमित ॲग्रीटेक</h4>
                            <h6>स्टार्टअप</h6> -->
                            <!-- <p>किसानने आम्हाला शेतकरी आणि कृषी व्यावसायिकांशी जोडण्यासाठी उत्कृष्ट व्यासपीठ मिळवून दिलं.
                                स्टॉलपासून ते सपोर्टपर्यंत सर्व काही अप्रतिम होतं. </p> -->
                            <!-- व्यवसायासाठी महत्वाच्या लीड्स आणि या सुंदर अनुभवासाठी किसानचे आभार! -->
                        </div>
                    </div>
                </div>
                 <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/visitor_2.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/visitor_2.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>रमेश</h4>
                            <h6>शेतकरी</h6> -->
                            <!-- <p>"आम्ही किसान आलो याचा आम्हाला खूप आनंद आहे! तिकीट दर खूपच परवडणारे होते आणि आम्हाला खूप
                                मौल्यवान माहिती मिळाली. धन्यवाद, किसान!"</p> -->
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="outerTesti">
                        <a href="/assets/images/me/Exhi_2.mp4" target="_blank">
                            <video autoplay muted loop playsinline #homeVideo>
                                <source src="/assets/images/me/Exhi_2.mp4" type="video/mp4">
                            </video>
                        </a>
                        <div class="mt-3 userInfo px-3 d-none">
                            <!-- <h4>अमित ॲग्रीटेक</h4>
                            <h6>स्टार्टअप</h6> -->
                            <!-- <p>किसानने आम्हाला शेतकरी आणि कृषी व्यावसायिकांशी जोडण्यासाठी उत्कृष्ट व्यासपीठ मिळवून दिलं.
                                स्टॉलपासून ते सपोर्टपर्यंत सर्व काही अप्रतिम होतं. </p> -->
                            <!-- व्यवसायासाठी महत्वाच्या लीड्स आणि या सुंदर अनुभवासाठी किसानचे आभार! -->
                        </div>
                    </div>
                </div>

                <!-- <div class="col-sm-1"> </div> -->
            </div>
        </div>
    </section>

    <section class="virtual-pass-section pb-5" *ngIf="isContestActive">
        <div class="container">
            <div class="virtual-pass-inner" (click)="onClickVote()">
                <div class="row">
                    <div class="image col-md-5">
                        <!-- <img src="/assets/images/me/Mobile-Pass.png" /> -->
                    </div>
                    <div class="col-md-7">
                        <div class="content">
                            <h1 class="tit pt-1">Vote for Innovation</h1>
                            <p class="virtual_description mb-0">KISAN Quest is a series of contests designed to discover 
                                    smart, practical ideas for agriculture and rural life. 
                                    Vote online for the ideas you believe are truly futuristic.
                            </p>
                            <br>
                            <a class="button" (click)="onClickVote()">
                                {{ isVotingActive ? 'Vote Now' : 'Explore Ideas' }}<span><i class="fa fa-arrow-right"></i></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="faq pt-2 d-none">
        <div class="container">
            <h1 class="tit font-weight-600 text-center mb-4">FAQ Section</h1>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                           Are kids allowed?
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Yes, children aged 5–12 can attend with a parent.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                           Is parking available?
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Yes, 50,000 sq. m. dedicated parking space.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                           Can I upgrade my ticket later?
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                           Yes, upgrades are allowed anytime before the event.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            What is included in the Business Pass?
                        </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            All days entry + access to the Networking Lounge for meetings and discussions.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="footSec d-none">
        <div class="container text-center">
            <h2>Plan your visit Today! </h2>
            <h2 class="text-white mb-3">India’s Largest Agri Show</h2>
            <h5>"Over 2,00,000 visitors and 600+ exhibitors are already joining. Make sure you are there.</h5>
            <div class="text-center mt-4 mb-4">
                <a (click)="onBuyTickets()" class="button" *ngIf="showBuyTicketButton">
                    <!-- <img class="me-1" src="/assets/images/me/tkt-icon.png" /> -->
                    Book Your Ticket
                    <span><i class="fa fa-arrow-right"></i></span>
                </a>
            </div>
        </div>
    </section>
    <div class="fMenu d-flex align-items-center justify-content-center d-none">
        <div><a href="https://pune.kisan.in/about" target="_blank">About KISAN</a></div>
        <div><a href="https://pune.kisan.in/booknow" target="_blank">Exhibitor</a></div>
        <div><a href="https://pune.kisan.in/tkt" target="_blank">Special Offers</a></div>
        <div><a href="https://pune.kisan.in/contact" target="_blank">Contact</a></div>
    </div>
</div>